import { Navigate, Outlet } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import { useAuth } from "../contexts/AuthContext";

const SellerPrivateRoute = () => {
  const { user, loading, userProfile, profileLoading } = useAuth();

  if (loading || profileLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
        <CircularProgress />
      </Box>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (userProfile?.isBuyer === true) {
    return <Navigate to="/comprador/vitrine" replace />;
  }

  return <Outlet />;
};

export default SellerPrivateRoute;
